import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { buildEndpoint } from '../EndPoints';

/** Videos: catálogo, reproducción con enlace firmado, administración y compras. */
const useVideoService = () => {
    const { doGet, doPost } = useFetch();

    const BASE_PATH = 'videos';

    const [fetchingCatalog, setFetchingCatalog] = useState(false);
    const [fetchingVideo, setFetchingVideo] = useState(false);
    const [fetchingStream, setFetchingStream] = useState(false);
    const [fetchingManage, setFetchingManage] = useState(false);
    const [fetchingSaveVideo, setFetchingSaveVideo] = useState(false);
    const [fetchingDeleteVideo, setFetchingDeleteVideo] = useState(false);
    const [fetchingPurchase, setFetchingPurchase] = useState(false);
    const [fetchingPurchases, setFetchingPurchases] = useState(false);

    const getCatalog = (filters: { search?: string; type?: string } = {}, events: ServiceEvents = {}) => {
        const query = Object.entries(filters)
            .filter(([, value]) => value)
            .map(([key, value]) => `${key}=${encodeURIComponent(String(value))}`)
            .join('&');
        doGet({ ...events, url: `${buildEndpoint(`${BASE_PATH}/catalog`)}?${query}`, setFetching: setFetchingCatalog });
    };

    const showVideo = (id: number, events: ServiceEvents = {}) => {
        doGet({ ...events, url: buildEndpoint(`${BASE_PATH}/${id}/show`), setFetching: setFetchingVideo });
    };

    // renew: renovación del enlace firmado de un video que ya se está viendo (no suma reproducción)
    const getStreamUrl = (id: number, events: ServiceEvents = {}, renew = false) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/stream${renew ? '?renew=1' : ''}`),
            setFetching: setFetchingStream
        });
    };

    const getManageVideos = (events: ServiceEvents = {}) => {
        doGet({ ...events, url: buildEndpoint(`${BASE_PATH}/manage`), setFetching: setFetchingManage });
    };

    const storeVideo = (data: FormData, events: ServiceEvents = {}) => {
        doPost({ ...events, url: buildEndpoint(`${BASE_PATH}/store`), body: data, setFetching: setFetchingSaveVideo });
    };

    const updateVideo = (id: number, data: FormData, events: ServiceEvents = {}) => {
        doPost({ ...events, url: buildEndpoint(`${BASE_PATH}/${id}/update`), body: data, setFetching: setFetchingSaveVideo });
    };

    const deleteVideo = (id: number, events: ServiceEvents = {}) => {
        doPost({ ...events, url: buildEndpoint(`${BASE_PATH}/${id}/delete`), setFetching: setFetchingDeleteVideo });
    };

    const purchaseVideo = (id: number, events: ServiceEvents = {}) => {
        doPost({ ...events, url: buildEndpoint(`${BASE_PATH}/${id}/purchase`), setFetching: setFetchingPurchase });
    };

    const getMyPurchases = (events: ServiceEvents = {}) => {
        doGet({ ...events, url: buildEndpoint(`${BASE_PATH}/my-purchases`), setFetching: setFetchingPurchases });
    };

    return {
        fetchingCatalog, fetchingVideo, fetchingStream, fetchingManage, fetchingSaveVideo,
        fetchingDeleteVideo, fetchingPurchase, fetchingPurchases,
        getCatalog, showVideo, getStreamUrl, getManageVideos, storeVideo, updateVideo,
        deleteVideo, purchaseVideo, getMyPurchases
    };
};

export default useVideoService;
